import { useMemo } from 'react'

import { GraphQLErrorBoundary } from '@shared/components/errors'
import { TradeTransactionType, useTradeByJobIdQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { TradeDetailHeading, TradeCard } from '../../components'

export interface TradeDetailProps {
  /**
   * Job ID.
   */
  jobId: string
  /**
   * Trade type. Can either be trade_mint or trade_withdrawal.
   */
  tradeType: TradeTransactionType
}

export const TradeDetail: React.FC<TradeDetailProps> = ({
  jobId,
  tradeType,
}) => {
  const { t } = useTranslation('payments')

  const { data, loading, error, refetch } = useTradeByJobIdQuery({
    variables: {
      jobId,
    },
  })

  const title = useMemo(() => {
    return t(
      tradeType === TradeTransactionType.trade_mint
        ? 'tradeDetail.title.mint'
        : 'tradeDetail.title.withdrawal',
    )
  }, [t, tradeType])

  return (
    <GraphQLErrorBoundary error={error} retry={refetch}>
      <TradeDetailHeading jobId={jobId} loading={loading} title={title} />
      <TradeCard
        loading={loading}
        trade={data?.tradeByJobId}
        tradeType={tradeType}
      />
    </GraphQLErrorBoundary>
  )
}
